import type { ModalEventType } from './Modal.types'

export const MODAL_EVENTS_TYPE: Record<string, ModalEventType> = {
  close: 'CLOSE',
  open: 'OPEN',
}
